export const config = {
    "theme": {
        "bs-primary-color": "#2870DB",
        "bs-top-menu-primary-color": "#2870DB",
        "bs-secondary-color": "#000222",
        "bs-text-primary-color": "#2870DB",
        "bs-text-secondary-color": "#5c5c5c",
        "bs-text-white": "#fff",
        "bs-text-mandatory": "#ff0000",
        "bs-breadcrumb-color": "#ededed",
        "bs-active-breadcrumb-color": "#000000",
        "bs-disabled-color": "#ededed",
        "bs-border-color": "#ededed",
        "bs-hr": "#ededed",
        "bs-table-border": "#ededed",
        "bs-table-header": "#d7e7ea",
        "bs-table-row": "#f2f2f2",
        "bs-table-row-list": "#212529",
        "bs-toast-header": "#d7e7ea",
        "bs-theme-background-color": "#000222"
    },
    "logo": {
        "loader": "assets/images/logo/accessforhealth/accessforhealthLoader.jpg",
        "main": "assets/images/logo/accessforhealth/accessforhealthMain.jpg",
        "favicon": "assets/images/favicon/accessforhealth/favicon.ico",
        "banner": "assets/images/banners/trinity/banner.jpg",
        "loginBanner": "assets/images/background/accessforhealth/accessforhealth-bg-image.jpg"
    },
    "contact": {
        "copyright": "",
        "phone": "",
        "servicePhone": "",
        "salesPhone": "",
        "fax": "",
        "email": "",
        "serviceEmail": "",
        "salesEmail": "",
        "address": {
            "lineOne": "",
            "lineTwo": "",
            "lineThree": ""
        }
    },
    "configuration": {
        "siteTitle": "Access For Health",
        "header": true,
        "footer": false,
        "privacyLink": true,
        "termsLink": true,
        "maintenance": false
    }
};